import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface TagsProps {
  tags: string[];
}

export const Tags = (props: TagsProps) => {
  return props.tags && props.tags.length > 0 ? (
    <>
      <dt className={DetailsTooltipStyles.DescriptionTerm}>{Messages.tags()}</dt>
      <dd className={DetailsTooltipStyles.DescriptionDetails}>
        { props.tags.join(', ') }
      </dd>
    </>
  ) : null;
};
